import React from "react";
import StatusCategoryContextProvider from "./StatuscategoryView";
import StatusCategory from "./view/StatusCategory";

const StatusCategoryPage = () => {
  return (
<StatusCategoryContextProvider>
<StatusCategory/>
</StatusCategoryContextProvider>
  );
};

export default StatusCategoryPage;
